import * as helpers  from './helpers'
import * as messages from './messages'

export default class Form
{
	init (form)
	{
		this.params = app_form_params || []
		this.form = form
		//this.rgpd = form.querySelector('input[name="rgpd"]')
		this.button = form.querySelector('button')
		this.loader = form.querySelector('.loader')
		
		form.addEventListener('submit', (e) =>
		{
			e.preventDefault()
			
			this.send()
		})
	}
	
	send ()
	{
		let data = helpers.serializeForm(this.form)
		
		if (data.error)
		{
			messages.add(false, data.message, this.form)
			
			return false
		}
		
		data += '&action=process_form&post_id=' + this.params.post_id + '&security=' + this.params.form_nonce
		
		helpers.req(this.form, this.params.ajax_url, data)
	}
}
